import { BILLING_API } from '@Constants/backendConstants';
import { useEntityAttachments } from '@Hooks/Attachments/useEntityAttachments';

/** Per-invoice attachments — thin wrapper over <c>useEntityAttachments</c> with the billing service URL baked in. */
export function useInvoiceAttachments(invoiceId: string | undefined) {
    return useEntityAttachments(BILLING_API, 'invoices', invoiceId);
}
